import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { UserLocationRequestModel } from 'model/mobile-app-dashboard';

@customElement('user-location-request')
export class UsersLocationRequestCustomElement {
  @bindable
  data: UserLocationRequestModel;

  async showUserLocation() {
    if (this.data.hasLocation)
      await this.data.showLocation(this.data.userUniqueId, this.data.userName);
  }
}
